import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-primary-800/60 bg-primary-950">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                我的家庭教师
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              专注电影、电视剧、综艺内容的影视资源门户，为家庭观影提供便捷的发现与浏览体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-300">
              影视分类
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {["电影", "电视剧", "综艺"].map((c) => (
                <li key={c}>
                  <Link
                    to={`/category/${encodeURIComponent(c)}`}
                    className="whitespace-nowrap text-foreground-500 transition-colors hover:text-accent-400"
                  >
                    {c}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/search"
                  className="whitespace-nowrap text-foreground-500 transition-colors hover:text-accent-400"
                >
                  影视搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-300">
              关于本站
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/about"
                  className="whitespace-nowrap text-foreground-500 transition-colors hover:text-accent-400"
                >
                  网站介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="whitespace-nowrap text-foreground-500 transition-colors hover:text-accent-400"
                >
                  联系方式
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="whitespace-nowrap text-foreground-500 transition-colors hover:text-accent-400"
                >
                  版权与免责声明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-300">
              联系我们
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li className="flex items-center gap-2 text-foreground-500">
                <i className="ri-mail-line text-base"></i>
                support@familytutor-media.cn
              </li>
              <li className="flex items-center gap-2 text-foreground-500">
                <i className="ri-phone-line text-base"></i>
                400-800-1234
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-800/70 text-foreground-400 transition-colors hover:border-accent-500/60 hover:text-accent-400"
                  >
                    <i className={`${icon} text-base`}></i>
                  </span>
                )
              )}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-800/60 pt-6 text-sm text-foreground-500 sm:flex-row">
          <p>© {year} 我的家庭教师 · 影视频道 保留所有权利</p>
          <p>本站内容仅用于影视资讯展示，版权归原权利人所有</p>
        </div>
      </div>
    </footer>
  );
}